// Operaciones puras sobre el array de secciones (bloques) del reporte de visita.
// Aisladas de React para poder testearlas sin render.

const BLOCK_DEFAULTS = {
  text: { title: 'Texto', config: () => ({ body: '' }) },
  checklist: { title: 'Checklist', config: () => ({ items: [] }) },
  signatures: { title: 'Firma', config: () => ({}) },
};

export const BLOCK_TYPES = Object.keys(BLOCK_DEFAULTS);

let seq = 0;

export const createBlock = (type) => {
  const def = BLOCK_DEFAULTS[type];
  if (!def) throw new Error(`Tipo de bloque desconocido: ${type}`);
  seq += 1;
  return {
    id: `b-${Date.now()}-${seq}`,
    type,
    title: def.title,
    visible: true,
    config: def.config(),
  };
};

// patch puede traer top-level (ej. {title}) y/o {config} (merge shallow con el
// config existente).
export const updateBlock = (blocks, id, patch) =>
  blocks.map((b) =>
    b.id === id
      ? { ...b, ...patch, config: patch.config ? { ...b.config, ...patch.config } : b.config }
      : b
  );

export const removeBlock = (blocks, id) => blocks.filter((b) => b.id !== id);

export const moveBlock = (blocks, index, dir) => {
  const target = index + dir;
  if (target < 0 || target >= blocks.length) return blocks;
  const next = [...blocks];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
};
